const links = [
	{
		label: 'Home',
		url: '/'
	},
	{
		label: 'Sobre mim',
		url: '/about'
	},
];

export default links;
